import { competitiveIntelligenceResearchTranslations } from './competitive-intelligence-research'
import { analyticsTranslations } from './analytics'

export const static_translation = {
  ...analyticsTranslations.Chinese,
    "audience_access_available_audiences": "可访问的受众",
    "audience_access_hcp": "医疗专业人员可访问",
    "audience_access_partner": "合作伙伴可访问",
    "audience_access_staff_us": "美国员工可访问",
    "audience_access_staff_global": "全球员工可访问",
  "upload_success": "上传已成功提交，正在等待审核。",
  "upload_title": "内容上传申请表",
  "context": '语境',
  "mvu_essentials_register_welcome": "Welcome to MagVenture Universe Lite",
  "mvu_essentials_register_access_notice": "Access with this code is limited to a specific number of people. Thank you for not sharing it.",
  "portal_registration_participant_limit_reached": "由于此访问权限已达到参与者人数上限，暂时无法注册。请联系负责您 MagVenture 访问权限的人员寻求帮助。",
  "portal_registration_invite_invalid": "此邀请链接无效或已过期。",
  "lite_registration_success_title": "注册完成",
  "lite_registration_success_email_text": "您的 MagVenture Universe Lite 访问权限已准备就绪。我们已发送包含访问链接的欢迎邮件。请使用刚刚注册的电子邮箱和密码登录。",
  "lite_registration_success_text": "您的 MagVenture Universe Lite 访问权限已准备就绪。请使用刚刚注册的电子邮箱和密码登录。",
  "lite_registration_success_action": "前往 Lite 登录",
  "accelerator_registration_success_title": "注册完成",
  "accelerator_registration_success_email_text": "您的 MagVenture Accelerator Program 访问权限已准备就绪。我们已发送包含访问链接的欢迎邮件。请使用刚刚注册的电子邮箱和密码登录。",
  "accelerator_registration_success_text": "您的 MagVenture Accelerator Program 访问权限已准备就绪。请使用刚刚注册的电子邮箱和密码登录。",
  "accelerator_registration_success_action": "前往 Accelerator 登录",
  "describe_as_upload": "请填写以下信息并上传您希望提交至 MagVenture Universe 的新内容文件。几天后，我们的支持团队将与您联系，提供有关您请求的更多信息。",
  "title": "标题",
  "table": "内容类型",
  "tags": "标签",
  "tag-types": "标签类型",
  "categories": "分类",
  "sub-categories": "子分类",
  "document": "文档",
  "image": "图片",

  "cancel": "取消",
  "send": "发送",
  'share_link': '分享链接',
  'share_link_description': '任何拥有此链接的人都可以在 {days} 天内访问此内容。请安全地复制并分享。',
  'share_link_label': '分享此链接：',
  'copy_link': '复制链接',
  'copied': '已复制！',
  'share_link_warning': '此链接将在 {days} 天后过期。',
  'share_link_duration': '有效期（天）',
  'copy': '复制',
  "term_title": "Cookie 和隐私声明",
  "register": "注册",
  "login": "登录",
  "email": "电子邮箱",
  "registration_professional_email_hint": "请使用您的工作邮箱，例如 name@yourclinic.com。",
  "password": "密码",
  "signin": "登录",
  "session_expired_sign_in_again": "您的会话已过期。请重新登录以继续。",
  "reset_password": "重置密码",
  "fill_the_field": "请填写此字段",
  "success": "谢谢！",
  "onboarding": "入门视频",
  "account_successfully_created": "我们的团队会审核您的申请，如需更多信息将与您联系。您的账户获批并可使用后，您将收到一封电子邮件。",
  "close": "关闭",
  "salutation": "称呼",
  "first_name": "名字",
  "last_name": "姓氏",
  "company_name": "公司名称",
  "job_title": "职位/职务",
  "industry": "行业",
  "state": "州/省",
  "zipcode": "邮政编码",
  "phone_number": "电话号码",
  "password_confirmation": "确认密码",
  "mr": "先生",
  "mrs": "女士",
  "ms": "小姐",
  "signup": "注册",
  "are_you_a_patient_or_a_therapist": "您是患者还是治疗师？",
  "create_your_password": "创建您的密码",
  "finish": "完成",
  "create_your_account": "创建您的账户",
  "back": "返回",
  "next": "下一步",
  "create_a_password": "创建密码",
  "enter_a_password_for_your_account": "为您的账户输入密码",
  "subscribe_to_newsletter": "是的，我希望收到来自 MagVenture 的教育更新、TMS 资源和活动信息。",
  "subscribe_to_newsletter_information": "您可以随时取消订阅。我们尊重您的专业邮箱，只分享相关内容。",
  "i_accept_the": "我接受",
  "i_accept_the_united": "美国隐私政策",
  "privacy_policy": "隐私政策",
  "send": "发送",
  "back_to_login": "返回登录",
  "enter_your_email_to_recover_your_password": "输入您的电子邮箱以找回密码",
  "access_the_recovery_link_that_was_sent_to_your_email": "访问发送到您邮箱的重置链接",
  "check_your_email": "请检查您的电子邮箱",
  "new_password": "新密码",
  "confirm_new_password": "确认新密码",
  "new_password_and_new_password_confirmation_are_not_the_same": "新密码与确认密码不一致",
  "password_changed_successfully": "密码修改成功！",
  "create_a_new_password": "创建新密码",
  "enter_a_new_password_for_your_account": "为您的账户输入新密码",
  "save": "保存",
  "one_uppercase_letter": "至少一个大写字母",
  "one_number": "至少一个数字",
  "at_least_6_characters": "至少 6 个字符",
  "at_least_1_special_character": "至少 1 个特殊字符",
  "accept_terms": "接受条款",
  "password_and_password_confirmation_must_match": "密码和确认密码必须一致",
  "see_all": "查看全部",
  "watch_live_now": "立即观看直播",
  "courses_available_for_you": "为您提供的培训项目",
  "partners-and-staffs_available_for_you": "为您提供的 Partners and Staff 内容",
  "product-information_available_for_you": "为您提供的产品信息",
  "articles_available_for_you": "为您提供的文章",
  "podcasts_available_for_you": "为您提供的播客",
  "documents_available_for_you": "为您提供的文档",

  "support-materials_available_for_you": "为您提供的临床支持资料",
  "marketing-materials_available_for_you": "为您提供的诊所营销资料",
  "service-supports_available_for_you": "为您提供的 Service & Support 资料",
  "product-informations_available_for_you": "为您提供的诊所产品信息",
  "media-templates_available_for_you": "为您提供的社交媒体模板",
  "videos_available_for_you": "为您提供的视频",
  "photos_available_for_you": "为您提供的照片",

  "courses": "培训与学习",
  "partners-and-staffs": "Partners and Staff",
  "product-information": "产品信息",
  "articles": "文章",
  "podcasts": "播客",
  "documents": "文档",
  "home": "首页",
  "favorites": "收藏",
  "no_favorites_message": "您还没有添加任何收藏。",
  "favorites_workspace_title": "整理已保存内容",
  "favorites_workspace_description": "创建文件夹，在文件夹之间拖动条目，并更高效地整理已保存资料。",
  "favorites_unfiled": "未分类",
  "favorites_unfiled_caption": "新的收藏会先进入这里",
  "favorites_unfiled_description": "您保存但尚未整理到文件夹中的所有内容。",
  "favorites_folder_description": "将条目拖到这里、重新排序，或一次移动多个条目。",
  "favorites_new_folder": "新建文件夹",
  "favorites_create_folder": "创建文件夹",
  "favorites_folder_name_placeholder": "文件夹名称",
  "favorites_delete_folder_confirm": "删除此文件夹并将其中内容移回未分类吗？",
  "favorites_current_view": "当前视图",
  "favorites_grid": "网格",
  "favorites_list": "列表",
  "favorites_drag_hint": "拖动即可排序或移动",
  "favorites_selected": "已选择",
  "favorites_move_to": "移动到",
  "favorites_move_selected": "移动所选",
  "favorites_empty_unfiled": "保存课程或文件后，它们会先出现在这里，之后您可以再移动到文件夹。",
  "favorites_empty_folder": "此文件夹为空。您可以从其他文件夹拖动条目到这里，或使用批量移动。",
  "faq": "常见问题",
  "no_faqs_available": "暂无常见问题。",
  "support": "帮助",
  "contact_us": "联系我们",
  "my_account": "我的账户",
  "my_certificates": "我的证书",
  "logout": "退出登录",
  "search": "搜索",
  "frequently_asked_questions": "常见问题",
  "how_can_we_help_you": "我们能如何帮助您？",
  "add_new_ticket": "提交帮助请求",
  "all_tickets": "所有请求",
  "pending": "待处理",
  "closed_tickets": "已关闭请求",
  "videos_and_contents": "视频与内容",
  "ticket_information": "请求信息",
  "add_reply": "添加回复",
  "close_ticket": "关闭请求",
  "status": "状态",
  "ticket_id": "请求编号",
  "created_date": "创建日期",
  "category_department": "类别/部门",
  "give_feedback": "提供反馈",
  "how_would_you_rate_the_way_this_request_was_handled": "您如何评价此请求的处理方式？",
  "subject": "主题",
  "area_departament": "区域 / 部门",
  "message": "消息",
  "create_a_new_ticket": "创建新请求",
  "describe_as_soon_as_possible": "请描述您的问题并选择合适的部门，以便我们的团队尽快为您提供帮助。",
  "no_records_found": "未找到记录",
  "showing": "正在显示",
  "of": "共",
  "results": "条结果",
  "subject_title": "主题/标题",
  "last_updated": "最后更新",
  "cancel": "取消",
  "registration_data": "注册资料",
  "updated_successfully": "更新成功",
  "created_successfully": "创建成功",
  "edit": "编辑",
  "done": "完成",
  "filters": "筛选",
  "search.sections.trainingLearning": "培训与学习",
  "search.sections.documents": "文档",
  "search.sections.images": "图片",
  "category": "类别",
  "filter": "筛选",
  "clear": "清除",
  "support_materials": "临床支持资料",
  "marketing_materials": "诊所营销资料",
  "media_templates": "社交媒体模板",
  "videos": "视频",
  "photos": "照片",
  "support-materials": "临床支持资料",
  "marketing-materials": "营销资料",
    "sales-support-materials": "Sales Support Materials",
    "sales-support-materials_available_for_you": "Sales Support Materials available for you",
    "sales_support_materials_empty": "No sales support materials are available yet.",
    "sales_support_materials_error": "We could not load the sales support materials. Please try again.",
    "sales_support_materials_unavailable": "Sales support materials are temporarily unavailable",
  "service-supports": "Service & Support",
  "service_support": "Service & Support",
  "support_videos": "Support Videos",
  "support_videos_empty": "目前还没有可用的支持视频。",
  "support_videos_unavailable": "支持视频不可用",
  "support_videos_error": "无法加载支持视频，请重试。",
  "support_video_unavailable": "支持视频不可用",
  "support_video_media_missing": "视频不可用",
  "support_video_media_missing_description": "此支持视频尚未配置可播放的媒体。",
  "support_video_about": "关于此视频",
  "product-informations": "产品信息",
  "media-templates": "社交媒体模板",
  "login_title": "请登录",
  "login_title_essentials": "请登录 MagVenture Universe Lite",
  "accelerator_brand_name": "MagVenture",
  "accelerator_brand_program": "Accelerator Program",
  "login_title_accelerator": "Welcome to the MagVenture Accelerator Portal",
  "accelerator_welcome_intro": "This is your exclusive portal for everything you need to prepare for and participate in the MagVenture Accelerator.",
  "accelerator_welcome_details": "Here you’ll find clinical training focused specifically on Introduction to TMS, Major Depressive Disorder (MDD), and Obsessive Compulsive Disorder (OCD), along with materials and resources from the Accelerator program which will be posted after the program.",
  "accelerator_welcome_login": "Log in to access your training and Accelerator resources.",
  "welcome": "欢迎！这是您专属的门户，提供临床培训、诊所营销素材和媒体资源，包括视频、治疗照片和社交媒体模板。登录即可访问帮助您在使用 MagVenture 过程中取得成功的工具。",
  "existing_users": "已有账号",
  "enter_credentials_to_continue": "输入您的登录信息以继续之前的进度。",
  "new_users": "新用户",
  "register_link_text": "注册",
  "register_and_gain_access_part1": "需要账户？前往 ",
  "register_and_gain_access_part2": " 并获取我们专属学习与资源平台的完整访问权限。",
  "contact": "联系我们",
  "contact.topicCategory": "选择主题类别",
  "contact.topicCategory.label": "主题类别",
  "contact.chooseSubject": "请选择最符合您请求的主题。",
  "contact.message": "消息",
  "contact.message.label": "消息",
  "contact.describeIssue": "请详细描述您的问题。我们的团队会尽快回复。",
  "contact.fileAttachment": "附加文件",
  "contact.fileAttachment.label": "附件",
  "contact.attachmentHelp": "您可以选择性地附加与请求相关的截图或文件（例如 JPG、PNG、PDF、DOC）。",
  "contact.preferredContact": "首选联系方式",
  "contact.preferredContact.label": "首选联系方式",
  "contact.contactPreference": "您希望我们通过哪种方式就此问题与您联系？",
  "contact.maximum_characters": "最多：1000 个字符",
  "contact.email.label": "电子邮箱",
  "contact.phone.label": "电话",
  "contact.technical_support": "有关 MagVenture Universe 内容的问题",
  "contact.video_streaming": "视频播放问题",
  "contact.questions_about_products": "关于 MagVenture 产品/服务的问题",
  "contact.material_download": "资料下载问题",
  "contact.suggestion": "建议",
  "contact.other": "其他",
  "contact.file": "选择文件",
  "contact.submit": "提交",
  "contact.is_required": "为必填项",
  "contact.success": "联系信息提交成功",
  "register.undertems": "访问 MagVenture Universe 需经过审核和批准。注册请求的审批可能需要最多 2 个工作日。",
  "courses-webnars-trainning": "课程、网络研讨会和培训",
  "usshop": "美国商店",
  "chat": "聊天客服",
  "country": "国家",
  "verify_email": "验证电子邮箱",
  "enter_the_code_sent_to_your_email": "输入发送到您邮箱的验证码",
  "we_sent_a_code_to_email": "我们已向以下地址发送验证码：",
  "enter_verification_code": "输入验证码",
  "code_expires_in": "验证码将在以下时间后失效",
  "verify": "验证",
  "resend_code_in": "在以下时间后可重新发送验证码",
  "resend_code": "重新发送验证码",
  "a_new_code_has_been_sent": "新的验证码已发送。",
  "please_confirm_you_are_not_a_robot": "请确认您不是机器人。",
  "email_verified_successfully": "邮箱验证成功。",
  "continue": "继续",
  "notifications": "通知",
  "unread_notifications": "条未读通知",
  "unread_notification": "条未读通知",
  "unread": "未读",
  "mark_all_notifications_read": "全部标记为已读",
  "notifications_update_error": "无法更新通知。",
  "try_again": "重试",
  "notifications_load_error": "无法加载通知",
  "notifications_load_error_description": "请检查网络连接后重试。",
  "notifications_empty": "暂无通知",
  "notifications_empty_description": "更新和重要活动将在此处显示。",
  "notification_not_found": "未找到通知",
  "notification_not_found_description": "此通知已不可用，或您无权访问。",
  "back_to_notifications": "返回通知列表",
  "open_notification": "打开",
  "loading_notifications": "正在加载通知",
  "loading_notification": "正在加载通知",
  "notifications_subtitle": "在一个位置查看更新、新课程和重要活动。",
  "recent_activity": "最近活动",
  "notifications_all_read": "所有通知均已阅读",
  "staff_essentials_invites_title_required": "标题为必填项。",
  "staff_essentials_invites_updated": "邀请已更新。",
  "staff_essentials_invites_created": "邀请已创建。",
  "staff_essentials_invites_link_unavailable": "邀请链接不可用。",
  "staff_essentials_invites_link_copied": "邀请链接已复制。",
  "staff_essentials_invites_copy_prompt": "复制此邀请链接：",
  "staff_essentials_invites_eyebrow": "MagVenture Universe",
  "staff_essentials_invites_menu_title": "MVU Lite Invitations",
  "staff_essentials_invites_title": "MVU Lite Invitations",
  "staff_essentials_invites_subtitle": "创建 MagVenture Universe Lite 邀请链接，并跟踪每个链接已使用的注册数量。",
  "staff_essentials_invites_refresh": "刷新",
  "staff_essentials_invites_create": "创建邀请",
  "staff_essentials_invites_total": "邀请总数",
  "staff_essentials_invites_active": "有效",
  "staff_essentials_invites_registrations": "注册",
  "staff_essentials_invites_remaining": "剩余",
  "staff_essentials_invites_links": "邀请链接",
  "staff_essentials_invites_found_singular": "个邀请",
  "staff_essentials_invites_found_plural": "个邀请",
  "staff_essentials_invites_none_created": "尚未创建邀请链接",
  "staff_essentials_invites_syncing": "同步中",
  "staff_essentials_invites_live_data": "实时数据",
  "staff_essentials_invites_loading_links": "正在加载邀请链接...",
  "staff_essentials_invites_column_title": "标题",
  "staff_essentials_invites_column_link": "链接",
  "staff_essentials_invites_column_status": "状态",
  "staff_essentials_invites_column_used": "已用",
  "staff_essentials_invites_column_remaining": "剩余",
  "staff_essentials_invites_column_expires": "过期",
  "staff_essentials_invites_column_created": "创建时间",
  "staff_essentials_invites_column_actions": "操作",
  "staff_essentials_invites_active_status": "有效",
  "staff_essentials_invites_inactive_status": "停用",
  "staff_essentials_invites_unlimited": "无限制",
  "staff_essentials_invites_copy_link": "复制链接",
  "staff_essentials_invites_history": "历史",
  "staff_essentials_invites_edit": "编辑",
  "staff_essentials_invites_empty_title": "暂无 Lite 邀请",
  "staff_essentials_invites_empty_description": "创建第一个邀请链接以开始跟踪注册。",
  "staff_essentials_invites_edit_modal": "编辑邀请",
  "staff_essentials_invites_create_modal": "创建邀请",
  "staff_essentials_invites_generated_by_strapi": "邀请代码和公开链接由 Strapi 生成。",
  "staff_essentials_invites_field_title": "标题",
  "staff_essentials_invites_field_maximum_uses": "No. of users having access to this invitation",
  "staff_essentials_invites_field_expires_at": "过期时间",
  "staff_essentials_invites_history_modal": "邀请历史",
  "staff_essentials_invites_loading_history": "正在加载历史...",
  "staff_essentials_invites_no_institution": "无机构",
  "staff_essentials_invites_no_registrations": "此邀请暂无注册。",
  "staff_essentials_invites_locked_content_title": "内容访问权限",
  "lite_invite_default_content_help": "所有为 Lite 配置的内容默认均可访问。请使用高级选项自定义访问权限。",
  "staff_essentials_invites_locked_content_description": "使用此邀请注册的用户可以访问已勾选的内容。取消勾选某项即可阻止访问。",
  "staff_essentials_invites_locked_content_selected": "可访问",
  "staff_essentials_invites_locked_content_select_visible": "允许访问可见结果",
  "staff_essentials_invites_locked_content_clear": "锁定所有内容",
  "staff_essentials_invites_locked_content_search": "Search Lite content",
  "staff_essentials_invites_locked_content_filter": "Content type",
  "staff_essentials_invites_locked_content_all_types": "All types",
  "staff_essentials_invites_locked_content_loading": "Loading catalog...",
  "staff_essentials_invites_locked_content_empty": "No matching content.",
  "staff_essentials_invites_locked_content_error": "Could not load the Lite catalog.",
  "staff_essentials_invites_content_preset_title": "内容预设",
  "staff_essentials_invites_content_preset_description": "选择一个或多个组，以这些组的合并内容替换当前选择。然后可在下方自定义各项内容。",
  "staff_essentials_invites_content_preset_placeholder": "预定义内容组",
  "staff_essentials_invites_content_preset_custom": "自定义选择（无预设）",
  "staff_essentials_invites_content_preset_loading": "正在加载内容预设...",
  "staff_essentials_invites_content_preset_error": "无法加载内容预设。",
  "staff_essentials_invites_content_preset_empty": "没有可用的活动预设。你仍可手动选择内容。",
  "staff_essentials_invites_content_preset_applied": "已应用预设",
  "staff_essentials_invites_content_preset_applied_description": "这些内容已复制到邀请中。你可以在下方自定义，而不会更改 Strapi 组。",
  "exclusive_content_title": "Exclusive content",
  "exclusive_content_message": "This content is exclusive to MagVenture clients.",
  "survey_load_error": "无法加载此调查。",
  "survey_unavailable": "调查不可用",
  "survey_back_to_course": "返回课程",
  "survey_thank_you": "感谢您的反馈",
  "survey_completed_description": "您的回答已保存。您可以继续课程。",
  "survey_submitted": "已提交",
  "survey_continue_course": "继续课程",
  "survey_course_feedback": "课程反馈",
  "survey_intro_description": "请回答以下有关培训体验的问题。",
  "survey_questions": "个问题",
  "survey_minutes": "分钟",
  "survey_account_linked": "已保存到您的账户",
  "survey_start": "开始调查",
  "survey_progress": "调查进度",
  "survey_optional": "选填",
  "survey_required": "必填",
  "survey_text_placeholder": "在此输入您的回答...",
  "survey_back": "返回",
  "survey_submit": "提交反馈",
  "survey_continue": "继续",
  "survey_required_answer": "此问题为必填项。",
  "survey_required_before_quiz": "请先完成必填问卷，然后再开始此测验。",
  "survey_required_title": "需要完成问卷",
  "survey_open": "打开问卷",
  "survey_completed_action": "问卷已完成",
  "survey_complete_required": "完成必填问卷",
  "survey_course_completed": "课程已完成",
  "survey_next_step": "下一步",
  "survey_share_experience": "分享您的体验",
  "survey_opens_in": "问卷将在以下时间后打开",
  "survey_seconds": "秒",
  "survey_answer_now": "填写问卷",
  "survey_stay_here": "留在此处",
  "user_approvals_menu_title": "用户审批",
  "user_approvals_eyebrow": "访问管理",
  "user_approvals_title": "用户审批",
  "user_approvals_subtitle": "查看分配给您审批范围的待处理访问申请。",
  "user_approvals_pending_count": "待处理",
  "user_approvals_refresh": "刷新",
  "user_approvals_pending_requests": "待处理申请",
  "user_approvals_search_placeholder": "按姓名、电子邮件或公司搜索",
  "user_approvals_unavailable": "审批不可用",
  "user_approvals_auth_required": "请登录以访问审批申请。",
  "user_approvals_not_authorized": "此账户未关联有效的审批收件人。",
  "user_approvals_network_error": "网络错误，请重试。",
  "user_approvals_load_error": "无法加载审批申请。",
  "user_approvals_empty": "没有待处理的审批。",
  "user_approvals_empty_description": "分配给您范围的新申请将显示在此处。",
  "user_approvals_no_search_results": "没有匹配的审批",
  "user_approvals_no_search_results_description": "请尝试其他姓名、电子邮件或公司。",
  "user_approvals_created_at": "创建时间",
  "user_approvals_name": "姓名",
  "user_approvals_email": "电子邮件",
  "user_approvals_company": "公司",
  "user_approvals_country": "国家",
  "user_approvals_region": "地区",
  "user_approvals_location": "位置",
  "user_approvals_status": "状态",
  "user_approvals_actions": "操作",
  "user_approvals_approved": "已批准",
  "user_approvals_rejected": "已拒绝",
  "user_approvals_approve": "批准",
  "user_approvals_reject": "拒绝",
  "user_approvals_already_processed": "此审批申请已被处理。",
  "user_approvals_process_error": "无法处理此审批申请。",
  "user_approvals_approve_success": "用户已成功批准。",
  "user_approvals_reject_success": "用户已成功拒绝。",
  "user_approvals_manual_review_required": "需要人工审核",
  "user_approvals_company_informed": "注册时填写的公司",
  "user_approvals_phone": "电话",
  "user_approvals_customer_select": "客户 / 诊所",
  "user_approvals_search_companies": "搜索客户或诊所",
  "user_approvals_no_companies": "未找到匹配的客户或诊所",
  "user_approvals_company_load_error": "无法加载客户或诊所选项。",
  "user_approvals_confirm_title": "批准用户",
  "user_approvals_confirm_description": "请审核注册信息并在批准访问前确认客户关联。",
  "user_approvals_association_confirmation": "此用户将关联到：",
  "user_approvals_confirm_approval": "确认批准",
  "mag.title": "Maggie",
  "mag.subtitle": "Your learning companion",
  "mag.preview_badge": "Preview",
  "mag.open_aria": "Open Maggie assistant",
  "mag.close_aria": "Close Maggie assistant",
  "mag.launcher_tooltip": "Talk to Maggie",
  "mag.intro_title": "Hi! I'm Maggie.",
  "mag.intro_body": "How can I help?",
  "mag.dismiss_intro_aria": "Dismiss Maggie introduction",
    "mag.welcome": "你好！我是Maggie。今天你想了解什么？",
    "mag.welcome_named": "你好，{name}！我是Maggie。今天你想了解什么？",
  "mag.quick_actions_label": "Try asking",
  "mag.quick.find_course": "Find a course",
  "mag.quick.explore_trails": "Explore Learning Paths",
  "mag.quick.continue_learning": "Continue learning",
  "mag.quick.product_tutorials": "Find product tutorials",
  "mag.quick.about_magventure": "Learn how MagVenture works",
  "mag.placeholder": "Ask Maggie a question...",
  "mag.composer_label": "Message to Maggie",
  "mag.send_aria": "Send message to Maggie",
  "mag.preview_response": "我可以使用 MagVenture 学习资料库回答。",
  "mag.local_error": "Maggie 无法准备回答，请重试。",
  "mag.typing": "Maggie 正在准备回答",
  "mag.you_label": "Your message",
  "mag.mag_label": "Message from Maggie",
  "mag.avatar_fallback": "Maggie avatar fallback",
  "mag.loading": "Opening Maggie...",
    "mag.sources": "来源",
    "mag.page": "页",
  "mag.feedback_question": "这个回答有帮助吗？",
  "mag.feedback_up": "有帮助",
  "mag.feedback_down": "没有帮助",
  "mag.feedback_thanks": "感谢您的反馈。",
  "mag.feedback_error": "无法发送反馈。",
    "mag.feedback_form.title": "分享反馈",
    "mag.feedback_form.open": "点击这里分享反馈",
    "staff_essentials_invites_content_locked": "已锁定",
    "staff_essentials_invites_content_available": "已允许访问",
    "mag.feedback_form.description": "Your feedback will be saved in our internal inbox for the MagVenture team to review. Up to 4,000 characters.",
    "mag.feedback_form.placeholder": "Your feedback",
    "mag.feedback_form.submit": "Submit feedback",
    "mag.feedback_form.cancel": "Back to chat",
    "mag.competitor_feedback.prompt": "你好！我可以帮你探索Competitive Hub。你想了解什么？也可以点击下方的反馈按钮提交建议。",
    "mag.competitor_feedback.prompt_named": "你好，{name}！我可以帮你探索Competitive Hub。你想了解什么？也可以点击下方的反馈按钮提交建议。",
  "mag.competitor_feedback.placeholder": "Share your Competitor Hub feedback...",
    "mag.competitor_feedback.success": "Thank you! Your feedback has been saved for our team to review.",
    "mag.competitor_feedback.error": "Your feedback could not be saved. Your message is still in the form; please try again.",
  "mag.feedback_reason.not_helpful": "没有帮助",
  "mag.feedback_reason.wrong_source": "来源错误",
  "mag.feedback_reason.unclear": "不清楚",
  "mag.feedback_reason.too_general": "过于笼统",
  "mag.feedback_reason.unsafe": "不安全",
  "competitive_intelligence_menu_title": "竞争情报",
  "competitive_intelligence_eyebrow": "市场情报",
  "competitive_intelligence_title": "竞争情报",
  "competitive_intelligence_description": "查看 MagVenture 跟踪的竞争研究、市场信号和社交来源的最新概况。",
  "competitive_intelligence_freshness_unknown": "更新时间不可用",
  "competitive_intelligence_overview_heading": "情报概览",
  "competitive_intelligence_metric_competitors": "跟踪的竞争对手",
  "competitive_intelligence_metric_research": "研究记录",
  "competitive_intelligence_metric_market": "市场信号",
  "competitive_intelligence_metric_social": "社交帖子",
  "competitive_intelligence_sources_title": "研究来源",
  "competitive_intelligence_sources_description": "当前竞争情报数据库的覆盖范围和更新情况。",
  "competitive_intelligence_records": "条记录",
  "competitive_intelligence_sources_empty": "暂时没有来源级别的详细信息。",
  "competitive_intelligence_loading": "正在加载竞争情报概览",
  "competitive_intelligence_empty_title": "暂无情报数据",
  "competitive_intelligence_empty_description": "数据管道尚未发布概览记录。",
  "competitive_intelligence_denied_title": "无法访问",
  "competitive_intelligence_denied_description": "您的账户没有竞争情报访问权限。",
  "competitive_intelligence_unavailable_title": "竞争情报暂不可用",
  "competitive_intelligence_unavailable_description": "目前无法连接服务，请稍后重试。",
  "competitive_intelligence_error_title": "无法加载概览",
  "competitive_intelligence_error_description": "意外响应导致无法加载此概览。",
  ...competitiveIntelligenceResearchTranslations.Chinese
}
